










































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { padHeadPanel2,logoutPanel } from "@/components";
import { TbTbHandover } from "@/http";
import { tailFun } from "@/common/util/tail";
import goodsDetails from "./components/goodsDetails.vue";
import { fmoney } from "@/common/util/money";

@Component({
  components: {
    padHeadPanel2,
    goodsDetails,
    logoutPanel
  },
})
export default class changeShifts extends Vue {
  public $refs: {
    inventoryDetail: HTMLFormElement;
  };

  form: any = {};
  tailFun = tailFun;
  fmoney = fmoney;
  code = JSON.parse(localStorage.getItem("padUserinfo")).jobNumber;
  /**提示弹窗 */
  tipShow = false;
  tipTitle ="";
  tipText="";
  confirmText="";
  cancelText="";
  btnNums=1;
  tipType=1;
  isJj = false;

  async created() {
    this.init();
  }

  async init() {
    try {
      let res = await TbTbHandover.GetNewHandoverGoods({
        accountId: JSON.parse(localStorage.getItem("padUserinfo")).id,
      });
      if(res.workClass==null){
        this.isJj = true;
        this.form = Object.assign({}, res);
      }else{
        this.form = Object.assign({}, res, {
          timefirst: res.workClass.split(" - ")[0],
          timeend: res.workClass.split(" - ")[1],
          name: res.name.length > 3 ? res.name.slice(0, 3) : res.name
        });
        this.isJj = false;
      }
    } catch (error) {}
  }
  showgoods() {
    this.$refs["goodsDetails"].showFun();
  }
  //提示弹窗
  confirmJjb(){
    this.tipTitle = "交接班提醒";
    this.tipText = `点击【确定】后，系统将自动生成交接班报表并退出请检查账号是否仅登录在当前设备上，若登录在多台设备，请先退出登录其他设备。`;
    this.btnNums=2;
    this.confirmText = "确定";
    this.cancelText = "取消"
    this.tipType = 1;
    this.$nextTick(()=>{
        this.tipShow = true;
    })
  }
  /**提示弹窗 */
  async tipConfirm(){
      switch (this.tipType) {
          case 1:
              this.jjbout();
              break;
          default:
              break;
      }
      this.tipShow = false;
  }
  tipCancel(){
    this.tipShow = false;
  }
  async jjbout() {
    try {
      let res = await TbTbHandover.PostHandover({
        accountId: JSON.parse(localStorage.getItem("padUserinfo")).id,
      });
      localStorage.removeItem("padUserinfo");
      localStorage.removeItem("padToken");
      this.$router.push("/pad/padLogin2");
    } catch (error) {}
  }
  //直接退出
  goHome(){
    localStorage.removeItem("padUserinfo");
    localStorage.removeItem("padToken");
    this.$router.push("/pad/padLogin2");
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/changeShifts/changeShifts.vue